export const AzureMarketPlaceLink = 'https://portal.azure.com/#create/hub';
export const SessionBookingLink = 'https://arch-session.booking.smapiot.com';

export function getPortalLink(): string {
    const defaultLink = 'https://portal.piral.cloud';
    const envLink = process.env.PIRAL_CLOUD_PORTAL;
  
    return envLink === undefined ? defaultLink : envLink;
  }
  
export function getDocsLink(): string {
    const defaultLink = 'https://docs.piral.cloud';
    const envLink = process.env.PIRAL_CLOUD_DOCS;
  
    return envLink === undefined ? defaultLink : envLink;
  }

